export class InProgressApplicationRow {
  id: string;
  entityId: string;
  entityType: string;
  name: string;
  credentialName: string;
  applicationStatusLabel: string;
  credentialApplicationUpdatedOn: Date;

  constructor(init?: Partial<InProgressApplicationRow>) {
    Object.assign(this, init);
  }
}
